import { jsx } from "react/jsx-runtime";
import { useHeaderContext } from "../Header.js";
import buttonStyles from "./Button.module.scss.js";
function Button(props) {
  const context = useHeaderContext();
  return /* @__PURE__ */ jsx(
    "a",
    {
      href: props.href,
      className: buttonStyles.root,
      "data-variant": props.variant,
      "data-size": props.size,
      "data-full-width": props.fullWidth,
      onClick: props.eventPayload && ((e) => {
        context.emitLinkClickEvent(e, props.eventPayload);
      }),
      children: props.children
    }
  );
}
export {
  Button
};
